export default __webpack_public_path__ + "static/media/detail-icon.1741c695.svg";